// extracted by mini-css-extract-plugin
module.exports = {"center":"_3c257dd","thumbnail":"_009f2dd"};